// extracted by mini-css-extract-plugin
export var checkboxGroup = "checkbox-group-module--checkboxGroup--3cc84";
export var label = "checkbox-group-module--label--8f227";
export var spin = "checkbox-group-module--spin--2b756";